<lib-gung-accordion #acc="gungAccordion" class="quote-list">
  @for (cart of data; track cart.id; let i = $index) {
    <lib-gung-accordion-item [id]="cart.id" [customHeader]="true">
      <ng-template libGungAccordionHeader>
        <div class="quote-card-header">
          <div class="quote-meta">
            <div class="quote-title-row">
              <span class="quote-name">{{ cart.name }}</span>
              <span class="quote-date-sep">&middot;</span>
              <span class="quote-date">{{
                dateUtilService.parseDate(cart.creationDate) | date : dateUtilService.dateFormat
              }}</span>
            </div>
          </div>

          <div class="quote-actions">
            <button
              type="button"
              class="q-btn q-btn-primary"
              (click)="loadCart(cart); $event.preventDefault(); $event.stopPropagation()"
            >
              {{ 'LOAD_QUOTE' | translate }}
            </button>

            <button
              type="button"
              class="q-btn q-btn-ghost"
              (click)="donwloadQuotePDF(cart); $event.preventDefault(); $event.stopPropagation()"
            >
              <i class="far fa-file-pdf"></i>
              <span>{{ 'DOWNLOAD_QUOTE_PDF' | translate }}</span>
            </button>

            <button
              type="button"
              class="q-btn q-btn-ghost"
              (click)="showSavedCart(cart); fetchProductData(cart); $event.preventDefault(); $event.stopPropagation()"
            >
              <i class="fas" [ngClass]="accordion?.isExpanded(cart.id) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
              <span>{{ (accordion?.isExpanded(cart.id) ? 'HIDE_DETAILS' : 'SHOW_DETAILS') | translate }}</span>
            </button>

            <button
              type="button"
              class="q-btn q-btn-icon q-btn-danger"
              (click)="deleteCart(cart); $event.preventDefault(); $event.stopPropagation()"
              [attr.aria-label]="'DELETE' | translate"
            >
              <i class="fas fa-trash-alt"></i>
            </button>
          </div>
        </div>
      </ng-template>

      <ng-template libGungAccordionBody>
        <div class="quote-card-body">
          <div class="quote-description" *ngIf="cart.extra.description">
            <span class="quote-label">{{ 'DESCRIPTION' | translate }}</span>
            <p>{{ cart.extra.description }}</p>
          </div>

          <div class="quote-products" *ngIf="mapData[cart.id]; else loading">
            <table class="quote-table">
              <colgroup>
                <col class="col-id" />
                <col class="col-name" />
                <col class="col-qty" />
              </colgroup>
              <thead>
                <tr>
                  <th class="col-id">{{ 'ARTICLE_NUMBER' | translate }}</th>
                  <th class="col-name">{{ 'NAME' | translate }}</th>
                  <th class="col-qty">{{ 'QTY' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of mapData[cart.id]">
                  <td class="col-id">
                    <a [routerLink]="['/product/', row.product.id]">{{ row.product.id }}</a>
                  </td>
                  <td class="col-name">{{ row.product.name }}</td>
                  <td class="col-qty">{{ row.qty }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </ng-template>
    </lib-gung-accordion-item>
  }
</lib-gung-accordion>

<ng-template #loading>
  <div class="quote-loading">
    <i class="fa fa-spinner fa-spin"></i>
    <span>{{ 'LOADING' | translate }}</span>
  </div>
</ng-template>
